const operationMap = {
  CREATE: 'app.common.created',
  UPDATE: 'common.updated',
  DELETE: 'app.common.deleted',
  MERGE: 'app.common.merged',
  UNMERGE: 'audit.log.ticket.data.unmerge.to',
  SPLIT: 'ticket.details.split.split',
  TRASH: 'app.common.trashed',
  RESTORE: 'app.common.restored',
  RESOLVED: 'app.common.resolved',
  CLOSED: 'ticket.details.statuses.closed',
  DESCRIPTION: 'app.common.created',
  REQ_REPLY: 'app.common.received',
  TECH_REPLY: 'app.common.sent',
  REQ_NOTIFICATION: 'app.common.received',
  TECH_NOTIFICATION: 'app.common.sent',
  VENDOR_EMAIL: 'app.common.received',
  TECH_EMAIL: 'app.common.sent',
  TECH_INITIATED: 'app.common.created',
  ASSOCIATE: 'converted.to.project'
};

const ActorMap = {
  SLA: { icon: 'SlaMetric', key: 'entity.sla' },
  TIME_TRIGGER: { icon: 'TimeTriggers', key: 'admin.stepnavi.timetrigger' },
  EVENT_TRIGGER: { icon: 'EventTriggers', key: 'admin.stepnavi.eventTrigger' },
  PRIORITY_MATRIX: {
    icon: 'ImpactUrgencyPriority',
    key: 'entity.priorityMatrix'
  }
};

const messageKeyMap = {
  REQ_REPLY: 'reply.received.from',
  TECH_REPLY: 'reply.sent.by',
  REQ_NOTIFICATION: 'notification.sent.by',
  TECH_NOTIFICATION: 'notification.sent.by',
  TECH_EMAIL: 'reply.sent.by',
  VENDOR_EMAIL: 'reply.received.from',
  TECH_INITIATED: 'operation.performed.by',
  SPAM: 'marked.spam.by'
};

export { operationMap, ActorMap };
